import React, { createContext, useEffect, useRef, useContext, useState } from 'react'
import { OrderEngineContext } from './OrderEngineContext'
import axios from 'axios'

const billDevices = ['kiosk', 'pos', 'orderManager', 'ecrPos', 'secondeScreen', 'orderScreen']

const BillingContext = createContext()

const BillingProvider = ({ children, prefix = 'pos' }) => {
  const { brandID, token, app } = useContext(OrderEngineContext)
  const [subscriptions, setSubscriptions] = useState(localStorage.getItem(`${prefix}.subscriptions`) ? JSON.parse(localStorage.getItem(`${prefix}.subscriptions`)) : null)
  const [bills, setBills] = useState([])
  const timeoutRef = useRef(null)
  const [refresh, setRefresh] = useState(0)
  const [refreshBills, setRefreshBills] = useState(0)

  useEffect(() => {
    if(subscriptions != null) {
      localStorage.setItem(`${prefix}.subscriptions`, JSON.stringify(subscriptions))
    }
  }, [subscriptions])

  useEffect(() => {
    if (token && brandID) {
      const fetchSubscriptions = async () => {
        try {
          const response = await axios.get(`https://billing.app.barsoft.hu/api/v1/device/subscriptions/${brandID}`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'authorization': token
            }
          })
          if(response?.data?.success) {
            setSubscriptions(response.data.data)
          }
        } catch (error) {
        }
      }
      fetchSubscriptions()
    }
  }, [token, brandID, refresh])

  useEffect(() => {
    if (token && brandID && refreshBills % 5 === 0 && billDevices.includes(app)) {
      const fetchBills = async () => {
        try {
          const response = await axios.get(`https://billing.app.barsoft.hu/api/v1/device/bills/${brandID}`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'authorization': token
            }
          })
          if(response?.data?.success) {
            setBills(response.data.data)
          }
        } catch (error) {
        }
      }
      fetchBills()
    }
  }, [token, brandID, refreshBills, app])

  useEffect(() => {
    if(billDevices.includes(app) && timeoutRef.current === null) {
      timeoutRef.current = setTimeout(() => {
        setRefresh(refresh + 1)
        setRefreshBills(refreshBills + 1)
      }, 60000 * 60)
    }
    return () => {
      if(billDevices.includes(app) && timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [app])

  return (
    <BillingContext.Provider
      value={{
        subscriptions,
        bills,
        refreshNow: () => {
          setRefresh(1111)
          setRefreshBills(15)
        }
      }}
    >
      {children}
    </BillingContext.Provider>
  )
}

export { BillingContext, BillingProvider }
